export default __webpack_public_path__ + "static/media/Register atau Login.2ea8a355.svg";